import { render, staticRenderFns } from "./NotificacaoColaboracoes.vue?vue&type=template&id=0f7f3334&scoped=true"
import script from "./NotificacaoColaboracoes.vue?vue&type=script&lang=js"
export * from "./NotificacaoColaboracoes.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoColaboracoes.vue?vue&type=style&index=0&id=0f7f3334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7f3334",
  null
  
)

export default component.exports